import React from 'react';
export const ActiveModuleContext = React.createContext();